
import TableList from "@components/templates/tablelist";
import { HttpSubManageBillList } from "@/service/allotment";
import { mapGetters } from "vuex";
import mixin from "./mixin";
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpSubManageBillList,
    },
    computed: {
        ...mapGetters('dictionary', ['getOrgList', 'getCusproductList']),
        SearchsData() {
            return [
                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    options: this.getOrgList,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "调拨计划单号",
                    tag: 'vInput',
                    key: 'EQ_subTransferPlanNo',
                    show: true,
                },
                // {
                //     label: "来源单号",
                //     tag: 'vInput',
                //     key: 'EQ_sourceNo',
                //     show: true,
                // },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    show: true,
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
            ]
        },
        columns() {
            return [
                {
                    title: '调拨计划单号',
                    key: 'subTransferPlanNo',
                },
                // {
                //     title: '来源单号',
                //     key: 'sourceNo',
                // },
                {
                    title: '单据类型',
                    key: 'orderType',
                    render: (h, { row }) => this.findRenderLabel(this.getBillType, row.orderType)
                },
                {
                    title: '项目',
                    key: 'lineId',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId)
                },
                {
                    title: '单据状态',
                    key: 'subTransferPlanStatus',
                    maxWidth: 80,
                    render: (h, { row }) => {
                        const status = row.subTransferPlanStatus;
                        const { theme = 'default', label } = this.getBillStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{label}</vButton>
                    }
                },
                {
                    title: '操作',
                    width: 100,
                    align: 'center',
                    render: (h, { row }) => {
                        return h('vButton', {
                            props: {
                                theme: 'primary',
                            },
                            nativeOn: {
                                click: () => {
                                    this.$emit('on-data', row)
                                }
                            }
                        }, "选择")
                    }
                },
            ];
        },

    },

};
